/*

This looks for .bg-video elements with child <video> elements.

It converts data-src and data-mobile-src values to src values so that the video can be loaded and played.

The video data-src and data-mobile-src can be an attribute of the <video> or child <source>.

If there is no data-mobile-src attribute, the data-src value will be used for mobile.

*/


function bgVideo() {

  $('.bg-video').each( function() {

    var videoContainer = $(this);
    var videoElement = videoContainer.find('video');
    var srcElement = videoElement;
    if (videoElement.children('source').length) { // If video has inner <source> element
      srcElement = videoElement.children('source');
    }
    var loadedDesktop = false;
    var loadedMobile = false;

    // Play and show video
    function playVideo(videoElement) {
      videoElement[0].load();
      videoElement[0].play();
      videoContainer.addClass('loaded'); // Mark as loaded to display
    }

    function bgVideoLoad() {

      // Desktop
      if(window.innerWidth > 450) {
        if (loadedDesktop == false) { // Check video hasn't been loaded on desktop
          srcElement.attr('src', srcElement.attr('data-src')); // Apply video data-src as src
          // Play video
          playVideo(videoElement);
          // Mark as loaded for desktop
          loadedDesktop = true;
          loadedMobile = false;
        }
      } // desktop

      // Mobile
      else {
        if (!videoContainer.hasClass('desktop-only')) { // Check video is not desktop-only
          if (loadedMobile == false) { // Check video hasn't been loaded on mobile
            var thisVideoSrcMobile = srcElement.attr('data-mobile-src'); // Get video data-mobile-src
            if (typeof thisVideoSrcMobile !== 'undefined' && thisVideoSrcMobile !== false) { // If data-mobile-src exists
              srcElement.attr('src', thisVideoSrcMobile); // Apply video data-mobile-src as src
            }
            else { // Else use default data-src
              srcElement.attr('src', srcElement.attr('data-src')); // Apply video data-src as src
            }
            // Play video
            playVideo(videoElement);
            // Mark as loaded for desktop
            loadedMobile = true;
            loadedDesktop = false;
          }
        }
      } // mobile

    } // bgVideoLoad()

    bgVideoLoad();
    $(window).resize ( function() {	bgVideoLoad(); });

  }); // each

} // bgVideo()

if ($('.bg-video').length) {
  bgVideo();
}
